export default {
  BASE: '1px solid rgba(39, 46, 61, 0.1)',
  RADIUS: '10px',
  BUTTON_RADIUS: '4px',
  BUTTON_BORDER: '1px solid #d6011e',
  BUTTON_BORDER_DISABLED: '1px solid #f2f2f2',
  BUTTON_BORDER_DEFAULT: '1px solid #111111',
  MENU: {
    RADIUS: '6px',
  },
}
